import { useMutation } from '@tanstack/react-query';
import { stringify as toQueryString } from 'query-string';
import { IOperationResultNoValue } from '../../extViewmodels';
import { useApiClientContext } from '../../surveys/context';

export function useDeleteStripeSessionMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const { apiClient } = useApiClientContext();
	return useMutation({
		mutationFn: ({ sessionId, token }: { sessionId: string; token: string }) => {
			return apiClient.delete<string>(`stripe/auth/checkout-session?${toQueryString({ token, sessionId })}`);
		},
		onSuccess,
		onError,
	});
}
